import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Articulo } from '../interfaces/articulo.interface';

const base_url = `${ environment.base_url }/Articulos`;


@Injectable({
  providedIn: 'root'
})
export class ArticulosService {

  token:string = localStorage.getItem('tp-Token') || '';
  headers = new HttpHeaders({
    'Content-Type':'application/x-www-form-urlencoded',
    'Tp-Token': localStorage.getItem('tp-Token') || ''
  });


  constructor(private http: HttpClient) { }

  getAll(pagina:number, rows:number, desdeCodigo:string, hastaCodigo:string, desdeDescripcion:string, hastaDescripcion:string, desdeDescripcionCorta:string, hastaDescripcionCorta:string, desdeTipo:string, hastaTipo:string, bloqueados:boolean, orden:string, desc:number, idFamilia:number = 0, contiene: string = ''){
    const url = `${ base_url }/getAll?page=${pagina}&rows=${rows}&deart=${desdeCodigo}&haart=${hastaCodigo}&dedes=${desdeDescripcion
                  }&hades=${hastaDescripcion}&decor=${desdeDescripcionCorta}&hacor=${hastaDescripcionCorta}&bloq=${bloqueados}&detip=${desdeTipo
                  }&hatip=${hastaTipo}&order=${orden}&desc=${desc}&idfa=${idFamilia}&condes=${contiene}`;
    // console.log(url);
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getAllArticulosFamilias(pagina:number, rows:number, desdeCodigo:string, hastaCodigo:string, desdeDescripcion:string, hastaDescripcion:string, desdeDescripcionCorta:string, hastaDescripcionCorta:string, desdeTipo:string, hastaTipo:string, bloqueados:boolean, orden:string, desc:number, idFamilia:number = 0, contiene: string = '', idSubFamilia:number = 0, familiaArbol: boolean = false, incluirSubFamilias: number = 0, idFamiliaArbol: number = 0, idArticulo: number = 0){
    const url = `${ base_url }/getAllArticulosFamilias?page=${pagina}&rows=${rows}&adeart=${desdeCodigo}&ahaart=${hastaCodigo}&adedes=${desdeDescripcion
                  }&ahades=${hastaDescripcion}&adecor=${desdeDescripcionCorta}&ahacor=${hastaDescripcionCorta}&abloq=${bloqueados}&adetip=${desdeTipo
                  }&ahatip=${hastaTipo}&aorder=${orden}&desc=${desc}&aidfa=${idFamilia}&aidsfa=${idSubFamilia}&acondes=${contiene}&arbol=${familiaArbol
                  }&incluir=${incluirSubFamilias}&idfaa=${idFamiliaArbol}&idara=${idArticulo}`;
   //  console.log(url);
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getVentasCliente(desdeFecha:Date, hastaFecha:Date, idCliente: number = 0, pagina:number =1, rows:number = 15, orden:string = 'codigoArticulo', desc:number = 0, idFamilia:number = 0, idSubFamilia:number = 0, familiaArbol: boolean = false, incluirSubFamilias: number = 0, idFamiliaArbol: number = 0){
      const url = `${ base_url }/getVentasCliente/${desdeFecha}/${hastaFecha}/${idCliente}?page=${pagina}&rows=${rows}&lorde=${orden}&desc=${desc
      }&arbol=${familiaArbol}&aidfa=${idFamilia}&aidsfa=${idSubFamilia}&incluir=${incluirSubFamilias}&idfaa=${idFamiliaArbol
      }`;
      // console.log(url);
      
      return this.http.get(url, {headers: this.headers})
                      .pipe(
                        map(
                          (resp:any)=>{
                            const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                            return respuesta;
                          }
                        )
                      )
                      ;
    }

  getArticuloId(id:number){
    const url = `${ base_url }/getArticuloId/${id}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getArticuloBarrasoCodigo(codigo:string){
    const url = `${ base_url }/getArticuloBarrasoCodigo/${codigo}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getArticuloCodigo(codigo:string){
    const url = `${ base_url }/getArticuloCodigo/${codigo}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  actualizar(data:string, id:number){
    const url = `${ base_url }/putArticulo/${id}`;
    // console.log(url);
    
    return this.http.put(url, data, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  postArticuloJson(data:Articulo){
    const url = `${ base_url }/postArticuloJson`;
    // console.log(url);
    
    return this.http.post(url, data, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, detalle:resp.detalle, ultimoId: resp.totalPaginas};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  nuevo(data:string){
    const url = `${ base_url }/postArticulo`;
    // console.log(url);
    
    return this.http.post(url, data, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, detalle:resp.detalle, ultimoId: resp.totalPaginas };
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  // busquedaConPrecio(valor:string, pagina:number, rows:number){
  //   const url = `${ base_url }/getBusquedaArticuloConPrecio/${valor}?page=${pagina}&rows=${rows}`;
    
  //   return this.http.get(url, {headers: this.headers})
  //                   .pipe(
  //                     map(
  //                       (resp:any)=>{
  //                         const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
  //                         return respuesta;
  //                       }
  //                     )
  //                   )
  //                   ;
  // }

  busqueda(valor:string, pagina:number, rows:number){
    const url = `${ base_url }/getBusquedaArticulo/${valor}?page=${pagina}&rows=${rows}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getCombo(orden:string, controlStock: boolean = false, bloqueados: boolean = false){
    const url = `${ base_url }/getAll?&order=${orden}&stoc=${controlStock}&bloq=${bloqueados}`;
    // console.log(url);
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          // console.log(resp);
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getArticulosFamilias(idFamilia: number, idSubFamilia:number, orden:string){
    const url = `${ base_url }/getArticulosFamilias/${idFamilia}/${idSubFamilia}/${orden}`;
    // console.log(url);
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          // console.log(resp);
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getArticulosCamping(){
    const url = `${ base_url }/getArticulosCamping`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getArticulosBraisChas(){
    const url = `http://localhost/apiBraisChas/Articulos.php`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  grabarArticulos(data:Articulo[]){
    const url = `${ base_url }/postArticulos`;
    // console.log(url);
    
    return this.http.post(url, data, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  grabarArticulosBraisChas(data:Articulo[]){
    const url = `${ environment.base_url }/ArticulosBraisChas/postArticulos`;
    // console.log(url);
    
    return this.http.post(url, data, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  modificarArticulosBraisChas(data:Articulo[]){
    const url = `${ environment.base_url }/ArticulosBraisChas/putArticulos`;
    // console.log(url);
    
    return this.http.post(url, data, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  actualizarPrecioCoste(idArticulo: number, precioCoste: number){
    const url = `${ base_url }/actualizarPrecioCoste/${idArticulo}/${precioCoste}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  actualizarPvp(idArticulo: number, pvp: number){
    const url = `${ base_url }/actualizarPvp/${idArticulo}/${pvp}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getCajasArticulos(idArticulo: number){
    const url = `${ base_url }/getCajasArticulo/${idArticulo}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          // console.log(resp);
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getRecetaArticulo(idArticulo: number){
    const url = `${ base_url }/getRecetaArticulo/${idArticulo}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          // console.log(resp);
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  cambiarCodigoArticulo(oldCodigo: string, newCodigo: string){
    const url = `${ base_url }/cambiarCodigoArticulo/${oldCodigo}/${newCodigo}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          // console.log(resp);
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  cambiarCodigoArticuloId(id: number, newCodigo: string){
    const url = `${ base_url }/cambiarCodigoArticuloId/${id}/${newCodigo}`;
    
    return this.http.get(url, {headers: this.headers})
                    .pipe(
                      map(
                        (resp:any)=>{
                          // console.log(resp);
                          const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                          
                          return respuesta;
                        }
                      )
                    )
                    ;
  }

  getNextArticuloCodigo(){
      const url = `${ base_url }/getNextArticuloCodigo`;
      
      return this.http.get(url, {headers: this.headers})
                      .pipe(
                        map(
                          (resp:any)=>{
                            const respuesta = {status:resp.status, totalPaginas: resp.totalPaginas, detalle:resp.detalle};
                            return respuesta;
                          }
                        )
                      )
                      ;
    }
}
